import {PATHS} from "../../../../routing/paths";
import {CONTACT, OPERATOR_SHORT, SERVICE, type LegalDoc} from "./common";

/** Информация для установки и эксплуатации ПО (/installation-operation). */
export const INSTALLATION_OPERATION_DOC: LegalDoc = {
    title: "Информация для установки и эксплуатации ПО",
    linkLabel: "информация для установки и эксплуатации ПО",
    path: PATHS.installationOperation,
    updated: "25 августа 2026 г.",
    sections: [
        {
            title: "1. Системные требования",
            body: [
                `Для использования ${SERVICE} необходимо устройство с доступом в сеть Интернет.`,
                "Веб-версия: браузер Google Chrome 90+, Mozilla Firefox 90+, Safari 15+, Microsoft Edge 90+ с поддержкой JavaScript и Cookie. Рекомендуемое разрешение экрана — от 360×640 (мобильное) и выше.",
                "Мобильная версия (Android): устройство под управлением Android 8.0 (Oreo) или новее, не менее 2 ГБ оперативной памяти, 50 МБ свободного места на устройстве.",
                "Мобильная версия (iOS): устройство под управлением iOS 15.0 или новее (iPhone 6s и новее), не менее 50 МБ свободного места.",
                "Для использования геолокации (функция «Куда сходить») необходимо наличие GPS-модуля и включённая геолокация на устройстве.",
                "Для отправки голосовых заметок (мобильное приложение) требуется микрофон.",
                "Для отправки фотографий требуется камера или доступ к галерее устройства.",
            ],
        },
        {
            title: "2. Установка мобильного приложения",
            body: [
                "Android: приложение доступно в магазине приложений RuStore (https://www.rustore.ru/catalog/app/ru.forruss.app); ссылка также размещена на сайте forruss.ru. Откройте страницу приложения в RuStore, нажмите «Установить» и следуйте подсказкам магазина.",
                "iOS: приложение на данный момент находится в стадии разработки. Для пользователей iOS доступна веб-версия сервиса через браузер Safari.",
                "После установки откройте приложение и нажмите «Создать анкету» для регистрации.",
            ],
        },
        {
            title: "3. Веб-версия (браузер)",
            body: [
                "Веб-версия доступна по адресу https://forruss.ru. Для входа перейдите на главную страницу и нажмите «Вход» или «Создать анкету».",
                "Веб-версия полностью функциональна и поддерживает все основные возможности сервиса: просмотр ленты, лайки, чаты, подписки, профиль. Для получения push-уведомлений необходимо разрешить их в браузере.",
                "Рекомендуется добавлять сайт на главный экран (iOS Safari: «Поделиться» → «На экран «Домой»; Android Chrome: «Меню» → «Добавить на главный экран») для быстрого доступа.",
            ],
        },
        {
            title: "4. Регистрация в сервисе",
            body: [
                "Для регистрации нажмите «Создать анкету» на главной странице. Укажите адрес электронной почты, имя, дату рождения, пол и город.",
                "После заполнения основных данных на указанный адрес электронной почты приходит письмо с кодом подтверждения. Введите код для завершения регистрации.",
                "После подтверждения email вы будете направлены на онбординг — короткий опрос для настройки рекомендаций AI-матчинга.",
                "После онбординга можно приступить к заполнению профиля: загрузить фотографии, указать интересы, описание, цели знакомства.",
            ],
        },
        {
            title: "5. Обновление программного обеспечения",
            body: [
                "Веб-версия обновляется автоматически при перезагрузке страницы — не требует действий со стороны пользователя.",
                "Мобильное приложение (Android): обновления распространяются через RuStore: магазин сам сообщит о новой версии, обновление устанавливается одним нажатием. При установке новой версии поверх существующей данные пользователя сохраняются.",
                "Рекомендуется обновлять приложение не реже одного раза в месяц для получения новых функций и исправления ошибок.",
                "О выходе новых версий сервис уведомляет через баннер в приложении или по email-рассылке (при наличии подписки на рассылку).",
            ],
        },
        {
            title: "6. Поддержка пользователей",
            body: [
                `По всем вопросам установки, эксплуатации и работы сервиса обращайтесь в службу поддержки: ${CONTACT}.`,
                "В приложении доступен раздел «Поддержка» (иконка в профиле), где можно оставить обращение, приложив скриншоты или описание проблемы.",
                "Среднее время ответа службы поддержки — до 24 часов в рабочие дни.",
                "В разделе «Поддержка» также доступны ответы на часто задаваемые вопросы (FAQ).",
            ],
        },
        {
            title: "7. Безопасность и требования к эксплуатации",
            body: [
                "Для обеспечения безопасности учётной записи используйте сложный пароль (не менее 8 символов, включая буквы разного регистра и цифры), не передавайте пароль третьим лицам.",
                "Завершайте сессию, нажимая «Выйти» в настройках профиля, если используете общее устройство.",
                `${OPERATOR_SHORT} не рекомендует устанавливать приложение из непроверенных источников. Единственным официальным источником является сайт forruss.ru.`,
                "При обнаружении ошибок в работе ПО, пожалуйста, сообщите в поддержку. Обновления, исправляющие ошибки, выпускаются по мере готовности.",
            ],
        },
    ],
};